module.exports = __webpack_public_path__ + "img/home.87be60bd.jpg";